import { WalletActivitiesPresentation } from '@/presentation/wallet/WalletActivitiesPresentation'
import { WalletPresentation } from '@/presentation/wallet/WalletPresentation'

export {
  WalletActivitiesPresentation,
  WalletPresentation
}
